import React from 'react';
import { Container, Row, Col } from '../../themes/MoGrid';
// import { Info, Body, RelatedStories, Gallery } from './index';
import Info from './Info/Info';
import Body from './Body/Body';
import RelatedStories from './RelatedStories/RelatedStories';
import Gallery from './Gallery/Gallery';
import { Helmet}  from "react-helmet";
import helper from 'components/utils/helper';
import { StoriesContainer, Share } from './Article.style';
import Dialog from '@material-ui/core/Dialog';
import ShareSocials from 'components/common/ShareSocials/ShareSocials';
import MoDialog from 'components/common/Dialog/Dialog';

const Article = ({cms, components}) => {
    const [openShare, setOpenShare] = React.useState(false);
    const {id, gallery, publishedDate, author, title, content, quote, quotePosition, wordCount, tags } = components;
    const currentTag = (new URLSearchParams(window.location.search).get('tag')) ?
        new URLSearchParams(window.location.search).get('tag') : ((tags && tags.length > 0) ? tags[0].name : '');

    function getAllStories() {
        let rawStories = (cms && cms.pages && cms.pages.stories && cms.pages.stories.components) ? cms.pages.stories.components : [];
        // Remove current story
        rawStories = rawStories.filter(story => {
            return story.components[0] !== id;
        });
        return rawStories.map(story => {
            let id = story.components[0];
            let item = cms.components[id];
            item.id = id;
            item.url = story.url;
            item.title = story.title;
            return item;
        });
    }
    
    function getRelatedStories(){
        let stories = [];
        let allStories = getAllStories();
        allStories.sort(function(a,b){
            if (a.publishedDate && b.publishedDate) {
                return new window.Date(b.publishedDate) - new window.Date(a.publishedDate);
            }
            return 0;
          });
        if(currentTag){
            stories = allStories.filter(story => {
                let includesTag = false;
                for(let i=0; i < story.tags.length; i++){
                    if((story.id !== id) && (story.tags[i].id === currentTag.toLowerCase())){
                        includesTag = true;
                        break;
                    }
                }
                return includesTag;
            }).slice(0,3);
        } else {
            stories = allStories.slice(0,3);
        }
        return stories;
    }

    return (
      <Container>
        {/* React Helmet to manage meta tags in document head */}
        <Helmet>
          <meta property="og:url" content={window.location.href} />
          <meta property="og:title" content={`Movember Story: ${title}`} />
          <meta property="og:type" content="article" />
          {gallery.length > 0 && (
            <meta property="og:image" content={helper.getImage(gallery[0])} />
          )}
        </Helmet>
        <StoriesContainer>
          <Gallery {...{ gallery }} />
          <Row>
            <Col xs={12} sm={8}>
              <Info {...{ publishedDate, author, title }} />
              <Body {...{ content, quote, quotePosition, wordCount, tags }} />
              <Share
                data-dl-category="content"
                data-dl-location="stories"
                data-dl-label="share page modal"
                onClick={() => setOpenShare(true)}
              >
                <i className="fas fa-share-alt" />
                Share
              </Share>
              <MoDialog open={openShare} onClose={()=> setOpenShare(false)}>
                <ShareSocials
                  onSelect={()=> setOpenShare(false)}
                  location="story"
                  shareUrl={window.location.href} 
                  getSocialContext={() => {
                    return {
                      title: title,
                      desc: title,
                      url: window.location.href
                    }
                  }}
                  />
              </MoDialog>
            </Col>
            <Col xs={12} sm={4}>
              {getRelatedStories().length > 0 && (
                <RelatedStories
                  stories={getRelatedStories()}
                  currentTag={currentTag}
                />
              )}
            </Col>
          </Row>
        </StoriesContainer>
      </Container>
    );
}
 
export default Article;